import { c as _c } from "react/compiler-runtime";
import { useState, useCallback, useMemo } from 'react';
import { groupNotifications, type DisplayNotification } from '../components/Flyout/NotificationsFlyout/utils';
import { useNotificationPresentationConfig } from '../components/Flyout/NotificationsFlyout/useNotificationPresentationConfig';
import { useQueryNotifications } from '../api';
import { useCurrentClient } from 'shared/context/ClientContext';
import { type UserNotificationResp } from 'shared/api/notifications';
const DISPLAY_PAGE_SIZE = 10;
interface UseNotificationsReturn {
  groupedNotifications: Record<string, DisplayNotification[]>;
  notificationsLoading: boolean;
  isProcessingMore: boolean;
  hasMoreToDisplay: boolean;
  loadMoreDisplayedNotifications: () => void;
  refetchNotifications: () => void;
  allNotifications: UserNotificationResp[];
}
interface UseNotificationsProps {
  unreadOnly?: boolean;
}
export const useNotifications = t0 => {
  const $ = _c(24);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    unreadOnly: t2
  } = t1;
  const unreadOnly = t2 === undefined ? false : t2;
  const [isProcessingMore, setIsProcessingMore] = useState(false);
  const [displayedCount, setDisplayedCount] = useState(DISPLAY_PAGE_SIZE);
  const {
    currentClient,
    isValidClient
  } = useCurrentClient();
  const notificationPresentationConfig = useNotificationPresentationConfig();
  const {
    data: t3,
    isLoading: notificationsLoading,
    refetch: refetchNotificationsQuery
  } = useQueryNotifications(currentClient.id, unreadOnly, isValidClient);
  let t4;
  if ($[2] !== t3) {
    t4 = t3 === undefined ? [] : t3;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const allNotifications = t4;
  let t5;
  bb0: {
    if (!Array.isArray(allNotifications) || allNotifications.length === 0) {
      let t6;
      if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {};
        $[4] = t6;
      } else {
        t6 = $[4];
      }
      t5 = t6;
      break bb0;
    }
    let t6;
    if ($[5] !== allNotifications || $[6] !== notificationPresentationConfig) {
      t6 = groupNotifications(allNotifications, notificationPresentationConfig);
      $[5] = allNotifications;
      $[6] = notificationPresentationConfig;
      $[7] = t6;
    } else {
      t6 = $[7];
    }
    t5 = t6;
  }
  const allGroupedNotifications = t5;
  let displayed;
  if ($[8] !== allGroupedNotifications || $[9] !== displayedCount) {
    displayed = {};
    let remainingToDisplay = displayedCount;
    for (const [dateKey, notificationsInGroup] of Object.entries(allGroupedNotifications)) {
      if (remainingToDisplay <= 0) {
        break;
      }
      const notificationsToAddCount = Math.min(remainingToDisplay, notificationsInGroup.length);
      const notificationsToAdd = notificationsInGroup.slice(0, notificationsToAddCount);
      if (notificationsToAdd.length > 0) {
        displayed[dateKey] = notificationsToAdd;
        remainingToDisplay = remainingToDisplay - notificationsToAdd.length;
      }
    }
    $[8] = allGroupedNotifications;
    $[9] = displayedCount;
    $[10] = displayed;
  } else {
    displayed = $[10];
  }
  const groupedNotificationsToDisplay = displayed;
  let count = 0;
  for (const dateKey_0 in allGroupedNotifications) {
    if (Object.hasOwn(allGroupedNotifications, dateKey_0)) {
      count = count + allGroupedNotifications[dateKey_0].length;
    }
  }
  const totalNotifications = count;
  const hasMoreToDisplay = displayedCount < totalNotifications;
  let t6;
  if ($[11] !== hasMoreToDisplay || $[12] !== isProcessingMore) {
    t6 = () => {
      if (isProcessingMore || !hasMoreToDisplay) {
        return;
      }
      setIsProcessingMore(true);
      setTimeout(() => {
        setDisplayedCount(_temp);
        setIsProcessingMore(false);
      }, 500);
    };
    $[11] = hasMoreToDisplay;
    $[12] = isProcessingMore;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const loadMoreDisplayedNotifications = t6;
  let t7;
  if ($[14] !== refetchNotificationsQuery) {
    t7 = () => {
      refetchNotificationsQuery();
    };
    $[14] = refetchNotificationsQuery;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const refetchNotifications = t7;
  let t8;
  if ($[16] !== allNotifications || $[17] !== groupedNotificationsToDisplay || $[18] !== hasMoreToDisplay || $[19] !== isProcessingMore || $[20] !== loadMoreDisplayedNotifications || $[21] !== notificationsLoading || $[22] !== refetchNotifications) {
    t8 = {
      groupedNotifications: groupedNotificationsToDisplay,
      notificationsLoading,
      isProcessingMore,
      hasMoreToDisplay,
      loadMoreDisplayedNotifications,
      refetchNotifications,
      allNotifications
    };
    $[16] = allNotifications;
    $[17] = groupedNotificationsToDisplay;
    $[18] = hasMoreToDisplay;
    $[19] = isProcessingMore;
    $[20] = loadMoreDisplayedNotifications;
    $[21] = notificationsLoading;
    $[22] = refetchNotifications;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};
function _temp(prevCount) {
  return prevCount + DISPLAY_PAGE_SIZE;
}